import { render, staticRenderFns } from "./DeviceScreen.vue?vue&type=template&id=dc52350c&scoped=true&"
import script from "./DeviceScreen.vue?vue&type=script&lang=js&"
export * from "./DeviceScreen.vue?vue&type=script&lang=js&"
import style0 from "./DeviceScreen.vue?vue&type=style&index=0&id=dc52350c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc52350c",
  null
  
)

export default component.exports